module.exports = __webpack_public_path__ + "img/8.a4ccded8.png";